import PropTypes from 'prop-types'
import React from 'react'
import { PageHeader, PageContent } from 'SRC/ui'
import { UpdateForm } from '../../UpdateForm'
import { getUserInfo, getProfileLoading } from '../../../selectors'
import { connect } from 'react-redux'
import { Preloader } from 'SRC/ui/Preloader'
import config from 'SRC/config/config.yaml'

const isServiceProvider = type => type === config.userTypes.serviceProviderSeo

export const My = ({ type, isLoading }) => [
  <PageHeader key='header'>Korisnički profil</PageHeader>,
  <PageContent key='content' additionalClass={isServiceProvider(type) ? 'registracija-adresar' : ''}>
    <div className='registracija-content-heading'>
      <p className='heading'>Dobrodošli u Korisnički profil</p>
      <p>Čestitamo! Uspješno ste registrovani. Savjetujemo da dodatno popunite vaš profil, kako bi uživali sve
        benefite koje sajt pruža.</p>
    </div>
    <UpdateForm />
    {isLoading ? <Preloader /> : null}
  </PageContent>
]

const mapStateToProps = state => {
  const info = getUserInfo(state)
  return {
    type: info && info.type && info.type.seo,
    isLoading: getProfileLoading(state)
  }
}

My.propTypes = {
  type: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired
}

My.defaultProps = {
  isLoading: false
}

export default connect(mapStateToProps)(My)
